<awc-form-select
  label="Aerodynamics"
  placeholder="Aerodynamics..."
  [options]="aerodynamics"
  [value]="[selectedAero[0] + '']"
  (valueChange)="selectionIDSet('' + $event?.[0], 'aero_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<awc-form-select
  label="Mass"
  placeholder="Mass..."
  [options]="masses"
  [value]="[selectedMass[0] + '']"
  (valueChange)="selectionIDSet('' + $event?.[0], 'mass_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<awc-form-select
  label="Wheel"
  placeholder="Wheel..."
  [options]="wheels"
  [value]="[selectedWheel[0] + '']"
  (valueChange)="selectionIDSet('' + $event?.[0], 'wheel_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<awc-form-select
  label="Deceleration Limit"
  placeholder="Optional"
  [options]="limits"
  [value]="selectedLimitCleaned"
  (valueChange)="selectionIDSet('' + $event?.[0], 'deceleration_limit_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<div class="two-col-inputs">
  <app-input
    label="Speed"
    placeholder="speed..."
    [value]="part.speed"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.SPEED"
    [id]="part.id+'_speed'"
    [updater]="update"
    (update)="setPart.emit([''+$event, 'speed', part.id+'_speed'])"></app-input>
  <app-input
    label="State of Charge"
    placeholder="State of Charge..."
    [value]="part.state_of_charge"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.RATIO"
    [id]="part.id+'_state_of_charge'"
    [updater]="update"
    (update)="setPart.emit([''+$event, 'state_of_charge', part.id+'_state_of_charge'])"></app-input>
</div>
<div class="two-col-inputs">
  <app-input
    label="Altitude"
    placeholder="altitude..."
    [value]="part.altitude"
    [unit]="UnitType.LENGTH"
    [type]="InputTypes.NUMBER"
    [id]="part.id+'_altitude'"
    [updater]="update"
    (update)="setPart.emit([''+$event, 'altitude', part.id+'_altitude'])"></app-input>
  <app-input
    label="Headwind"
    placeholder="Headwind..."
    [unit]="UnitType.SPEED"
    [value]="part.headwind"
    [type]="InputTypes.NUMBER"
    [id]="part.id+'_headwind'"
    [updater]="update"
    (update)="setPart.emit([''+$event, 'headwind', part.id+'_headwind'])"></app-input>
</div>
<div class="two-col-inputs">
  <app-input
    label="Gradient"
    placeholder="Gradient..."
    [value]="part.gradient"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.GRADIENT"
    [id]="part.id+'_gradient'"
    [updater]="update"
    (update)="setPart.emit([''+$event, 'gradient', part.id+'_gradient'])"></app-input>
  <app-input
    label="Acceleration"
    placeholder="Acceleration..."
    [value]="part.acceleration"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.ACCELERATION"
    [id]="part.id+'_acceleration'"
    [updater]="update"
    (update)="setPart.emit([''+$event, 'acceleration', part.id+'_acceleration'])"></app-input>
</div>

<div class="axle-cont">
  <div class="selects">
    <app-input
      label="Front Axle Split"
      placeholder="Front Axle Split Ratio"
      [unit]="UnitType.RATIO"
      [type]="InputTypes.NUMBER"
      [value]="part.front_axle_split"
      [disabled]="axleSplitStrategy === 'max_efficiency'"
      [readOnly]="axleSplitStrategy === 'max_efficiency'"
      (update)="setPart.emit([''+$event, 'front_axle_split', part.id+'front_axle_split'])"
    ></app-input>
    <awc-form-select
      label="Axle Split Strategy"
      placeholder="Select Axle Split Strategy"
      [options]="axleSplitStrategies"
      [value]="[axleSplitStrategy + '']"
      (valueChange)="changeAxleSplitStrategy('' + $event?.[0])"
      [size]="AWCFormElementSize.SMALL">
    </awc-form-select>

  </div>
</div>

<div>
  <awc-form-switch
    label="Continuous Thermal Performance"
    [value]="part.steady_state || false"
    (valueChange)="setSteadyState('' + $event)"
    [size]="AWCFormElementSize.SMALL"
    [awcTooltipText]="'If selected, the static requirement calculation will iterate until all components reach a steady state temperature.'"
  ></awc-form-switch>
</div>
<div>
  <awc-form-switch
    label="Temperature Limited Capability Curve"
    [value]="part.steady_state_capability_curve || false"
    [disabled]="!part.steady_state"
    (valueChange)="setPart.emit([''+$event, 'steady_state_capability_curve', part.id+'steady_state_capability_curve'])"
    [size]="AWCFormElementSize.SMALL"
    [awcTooltipText]="'If selected, the capability curve will be subject to any component temperature limits.'"
  ></awc-form-switch>
</div>
